import axios from "@/plugins/axios";

let url = "/api/console/user-restrictions";

// 회원별 이용제한
export default {
    getRestrictions(data){
        return axios.get(url, data).then(result => result.data);
    },
    postRestriction(data){
        return axios.post(url, data).then(result => result.data);
    },
    putRestriction(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    deleteRestriction(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    }
}
